// frontend/src/api/callLogAPI.js
import axios from 'axios';
import { API_BASE_URL, authHeader } from './axiosConfig';

const callLogAPI = {
  // params: page, limit, search, outcome, startDate, endDate, followUpToday, converted, loggedBy
  getCallLogs: (params = {}) =>
    axios.get(`${API_BASE_URL}/call-logs`, { headers: authHeader(), params })
      .then(r => r.data),

  getById: (id) =>
    axios.get(`${API_BASE_URL}/call-logs/${id}`, { headers: authHeader() })
      .then(r => r.data),

  getUsers: () =>
    axios.get(`${API_BASE_URL}/users`, { headers: authHeader() })
      .then(r => r.data),

  getStats: () =>
    axios.get(`${API_BASE_URL}/call-logs/stats`, { headers: authHeader() })
      .then(r => r.data),

  getToday: (limit = 5) =>
    axios.get(`${API_BASE_URL}/call-logs/today`, { headers: authHeader(), params: { limit } })
      .then(r => r.data),

  createCallLog: (data) =>
    axios.post(`${API_BASE_URL}/call-logs`, data, { headers: authHeader() })
      .then(r => r.data),

  updateCallLog: (id, data) =>
    axios.put(`${API_BASE_URL}/call-logs/${id}`, data, { headers: authHeader() })
      .then(r => r.data),

  convertToLead: (id, leadId = null) =>
    axios.put(`${API_BASE_URL}/call-logs/${id}/convert`, { lead_id: leadId }, { headers: authHeader() })
      .then(r => r.data),

  getOverdueCount: () =>
    axios.get(`${API_BASE_URL}/call-logs/overdue-count`, { headers: authHeader() })
      .then(r => r.data.count),

  deleteCallLog: (id) =>
    axios.delete(`${API_BASE_URL}/call-logs/${id}`, { headers: authHeader() })
      .then(r => r.data),
};

export default callLogAPI;
